"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useMemo } from "react";
import { useUserData } from "@/hooks/useUserData";
import { canPerformTierWrite, getEffectivePricingTier, isFreemiumOrPremiumTier, isSystemViewAllowedForTier, type TierGuardContext, type TierWriteAction } from "@/lib/services/tier/tier-guard";
import type { PricingTier } from "@/prisma/generated/enums";
export function useTierGuard() {
  const $ = _c(22);
  const {
    organization
  } = useUserData();
  let t0;
  bb0: {
    if (!organization) {
      t0 = null;
      break bb0;
    }
    const t1 = organization.expiresAt ?? null;
    const t2 = organization.pricingTier as PricingTier;
    let t3;
    if ($[0] !== organization.tierAllowedSystemViewNames) {
      t3 = organization.tierAllowedSystemViewNames ?? [];
      $[0] = organization.tierAllowedSystemViewNames;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
      t4 = {
        expiresAt: t1,
        pricingTier: t2,
        tierAllowedSystemViewNames: t3
      };
      $[2] = t1;
      $[3] = t2;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    t0 = t4;
  }
  const context = t0;
  let t1;
  if ($[6] !== context) {
    t1 = context ? getEffectivePricingTier(context) : null;
    $[6] = context;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const effectivePricingTier = t1;
  let t2;
  if ($[8] !== context) {
    t2 = action => context ? canPerformTierWrite(context, action) : false;
    $[8] = context;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const canWrite = t2;
  let t3;
  if ($[10] !== context) {
    t3 = systemViewName => context ? isSystemViewAllowedForTier(context, systemViewName) : false;
    $[10] = context;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const isSystemViewAllowed = t3;
  let t4;
  if ($[12] !== context) {
    t4 = context ? isFreemiumOrPremiumTier(context) : null;
    $[12] = context;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const hasFullProductAccess = t4;
  const t5 = organization != null;
  const t6 = organization?.pricingTier ?? null;
  let t7;
  if ($[14] !== canWrite || $[15] !== context || $[16] !== effectivePricingTier || $[17] !== hasFullProductAccess || $[18] !== isSystemViewAllowed || $[19] !== t5 || $[20] !== t6) {
    t7 = {
      canWrite,
      context,
      effectivePricingTier,
      hasFullProductAccess,
      isSystemViewAllowed,
      isTierResolved: t5,
      pricingTier: t6
    };
    $[14] = canWrite;
    $[15] = context;
    $[16] = effectivePricingTier;
    $[17] = hasFullProductAccess;
    $[18] = isSystemViewAllowed;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}